import { ReactNode, useCallback } from 'react';

import { Box, Dialog, ClickAwayListener } from '@mui/material';

import { dialogSx, containerSx } from './CommandPalette.styles';

export interface CommandPaletteBaseProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  labelledBy?: string;
}

export const CommandPaletteBase = ({
  open,
  onClose,
  children,
  onKeyDown,
  labelledBy,
}: CommandPaletteBaseProps) => {
  const handleClickAway = useCallback((): void => {
    onClose();
  }, [onClose]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      disableAutoFocus
      sx={dialogSx}
      onKeyDown={onKeyDown}
      aria-labelledby={labelledBy}
    >
      <ClickAwayListener onClickAway={handleClickAway}>
        <Box sx={containerSx}>{children}</Box>
      </ClickAwayListener>
    </Dialog>
  );
};
